import React from "react";

export default function Questions() {
  return (
    <section class="faq section-padding prelative" id="duda">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="sectioner-header text-center">
              <h3>Preguntas frecuentes</h3>
              <span class="line"></span>
              <p></p>
            </div>
            <div class="section-content">
              <div class="row">
                <div
                  class="col-md-6 faq-content wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h4>¿Cómo puedo empezar a utilizar tu servicio?</h4>
                  <p>
                    Solo tendrias que usar uno de los enlaces que aparecen en
                    nuestra Web seras dirigido a una de nuetras salas de chats.
                  </p>
                </div>
                <div
                  class="col-md-6 faq-content wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <h4>
                    ¿Cómo se comparan los beneficios de nuestro servicio con los
                    de la competencia?
                  </h4>
                  <p>
                    Nuestro servicio ha demostrado una alta fidelidad en los
                    métodos de pago por cualqiuer plataforma cubana, rapidez de
                    solución a sus problemas y una mejora constante del alcance
                    de cada negoico con el que trabajamos.
                  </p>
                </div>
                <div
                  class="col-md-6 faq-content wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <h4>¿Cuál es el costo del servicio y qué incluye?</h4>
                  <p>
                    El costo del servicio varía entorno a las necesidades del
                    cliente, ya que creamos una solución a medida para cada uno.
                    Incluimos: creación de marca(branding), landing pages,
                    cartas o menús digitales, tiendas virtuales.
                  </p>
                </div>
                <div
                  class="col-md-6 faq-content wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <h4>
                    ¿Cómo puedo contactar al servicio de atención al cliente si
                    tengo alguna pregunta o problema?
                  </h4>
                  <p>
                    En caso de necesitar asistencia o tener alguna duda de como
                    operar cualquiera de nuestros productos puede ir a un chat
                    de Whatsapp en vivo con uno de nuestros soportes mediante
                    los contactos que aparecen en la web.
                  </p>
                </div>
                <div
                  class="col-md-6 faq-content wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <h4>
                    ¿EL servicio de R & H ofrece promoción a nuestro negocio o
                    empresa?
                  </h4>
                  <p>
                    R & H no ofrece promoción directa a no ser que se pague
                    dentro de los acuerdos al iniciar un contrato. De manera
                    indirecta ofrecemos un boulevard donde tienen la posibilidad
                    de explorar los rentables que son otros negocios y asi
                    participar en colaboraiones entre marcas.
                  </p>
                </div>
                <div
                  class="col-md-6 faq-content wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <h4>
                    ¿Qué infraestructura debo tener para usar este servicio?
                  </h4>
                  <p>
                    Las necesidades son mínimas, no necesitas crear un página
                    web ni instalar ninguna aplicación. Nos encargamos de que
                    ganes el máximo con solo algunos requisitos.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
